// src/components/ToggleCell.jsx
import React from "react";

export default function ToggleCell({ exists, value, saving, onClick }) {
  const label = value === null ? "—" : value ? "On" : "Off";
  return (
    <button
      type="button"
      className={`ff-cell ${!exists ? "ff-cell-na" : value ? "ff-cell-on" : "ff-cell-off"} ${saving ? "ff-cell-saving" : ""}`}
      onClick={onClick}
      disabled={!exists || saving}
      title={!exists ? "Flag does not exist in this org" : saving ? "Saving..." : "Toggle"}
    >
      <span className="ff-cell-label">{label}</span>
      {saving && <span className="ff-cell-spinner" aria-hidden>⏳</span>}
    </button>
  );
}
